import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "select-custom-spending-limit" }
const _hoisted_2 = { class: "lead" }
const _hoisted_3 = { class: "selector" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "selector-option-title" }
const _hoisted_6 = { class: "selector-option-value" }
const _hoisted_7 = { class: "selector-option-title" }
const _hoisted_8 = {
  key: 1,
  class: "change-custom-spending-limit"
}
const _hoisted_9 = { class: "button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gs_alert_bar = _resolveComponent("gs-alert-bar")!
  const _component_BaseTooltip = _resolveComponent("BaseTooltip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_gs_button = _resolveComponent("gs-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_gs_alert_bar, {
      class: "mt-4",
      type: "warning",
      title: _ctx.t('limit_hit_warning_title'),
      message: _ctx.t('limit_hit_warning_description')
    }, null, 8, ["title", "message"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.t('spending_limit_title')), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.t('spending_limit_description')), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitTypes, (limit, type) => {
          return (_openBlock(), _createElementBlock("div", {
            key: type,
            class: _normalizeClass(["selector-option", { selected: _ctx.selectedLimitType === type }]),
            onClick: ($event: any) => (_ctx.selectLimit(type))
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.t(type)) + " ", 1),
              _createVNode(_component_BaseTooltip, {
                content: _ctx.t(`tooltip.${type}`),
                color: "#0017B4"
              }, null, 8, ["content"])
            ]),
            _createElementVNode("span", _hoisted_6, "$ " + _toDisplayString(_ctx.formatNumberByLocale(limit)) + " US Dollars", 1)
          ], 10, _hoisted_4))
        }), 128)),
        _createElementVNode("div", {
          class: _normalizeClass(["selector-option", { selected: _ctx.selectedLimitType === 'custom' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectLimit('custom')))
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('custom')), 1)
        ], 2)
      ]),
      (_ctx.selectedLimitType === 'custom')
        ? (_openBlock(), _createBlock(_component_v_form, {
            key: 0,
            modelValue: _ctx.isSpendingLimitFormValid,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isSpendingLimitFormValid) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.selectedSpendingLimit,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSpendingLimit) = $event)),
                modelModifiers: { number: true },
                label: _ctx.t('monthly_limit'),
                variant: "outlined",
                rules: [
          _ctx.rules.positiveInteger,
          _ctx.rules.minValue(
            _ctx.minLimit,
            _ctx.t('min_spending_limit', {
              min: _ctx.formatNumberByLocale(_ctx.minLimit),
              amount: _ctx.formatNumberByLocale(_ctx.selectedStore.spendingLimit?.used || 0),
              plan: _ctx.getPlanName(_ctx.selectedPlan || _ctx.currentPlanType),
            }),
          ),
          _ctx.rules.required,
        ],
                autofocus: "",
                "hide-details": false
              }, {
                "prepend-inner": _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("strong", null, "$", -1)
                ])),
                _: 1
              }, 8, ["modelValue", "label", "rules"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.currentSpendingLimit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t('current_spending_limit')) + " $" + _toDisplayString(_ctx.formatNumberByLocale(_ctx.currentSpendingLimit)), 1),
            _createVNode(_component_v_icon, { size: 24 }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("mdi-arrow-right")
              ])),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.t('selected_spending_limit')) + " $" + _toDisplayString(_ctx.formatNumberByLocale(_ctx.selectedSpendingLimit)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_gs_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('back'))),
          icon: "mdi-chevron-left",
          size: "large",
          type: "outlined",
          disabled: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CommonUi.back')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_gs_button, {
          onClick: _ctx.handleSave,
          loading: _ctx.loading,
          type: "primary",
          size: "large",
          "full-width": "",
          disabled: (_ctx.selectedLimitType === 'custom' && !_ctx.isSpendingLimitFormValid) || _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CommonUi.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"])
      ])
    ])
  ], 64))
}